import { useSelector } from 'core/common/hooks';
import { evalCondition } from 'core/common/utils/evalCondition';
import { getConditionAttributes } from 'core/funnel/store';
import { OffersAttributes } from 'core/offers/entities';

type Params = {
  attributes: Array<OffersAttributes>;
};

export const useFlowOffers = ({ attributes }: Params) => {
  const funnelConditions = useSelector(getConditionAttributes);

  const getOffers = () => {
    const offersWithCondition = attributes.find((item) => {
      if (item.condition) {
        return [funnelConditions].find(evalCondition(item.condition));
      }
    });

    if (!!offersWithCondition) {
      const { condition: _, ...offersByLocale } = offersWithCondition;

      return offersByLocale;
    }

    return attributes[attributes.length - 1];
  };

  return { offers: getOffers() };
};
